import React, { useEffect } from 'react';
import Modal from '~/app/common/Modal';
import classes from './style.module.scss';
import Header from './Header';
import Form from './Form';
import { useStoreActions, useStoreState } from '~/store';
import { IssueOrServiceType } from '~/app/data/statuses/chat';
import { WorkOrderTaskUserList } from '~/workorder/types';

export type TimeEntryMode = 'add' | 'edit';

export interface TimeEntryProps {
    open: boolean;
    mode: TimeEntryMode;
    workOrderId: number;
    taskId: number;
    type: IssueOrServiceType;
    initialEntry?: WorkOrderTaskUserList;
    onClose: () => void;
    onSaved: () => void;
}

export type TimeEntryComponent = React.FC<TimeEntryProps>;

const TimeEntry: TimeEntryComponent = ({open, mode, workOrderId, taskId, type, initialEntry, onClose, onSaved}) => {

    const departmentId = useStoreState(state => state.workOrder.data.departmentId);
    const netWorkStatus = useStoreState(state => state.app.offline.status);
    const costCategoryAction = useStoreActions(actions => actions.issue.fetchCostCategories);
    const fetchHPCodesAction = useStoreActions(actions => actions.issue.fetchHPCodes);
    const fetchWorkTypesAction = useStoreActions(actions => actions.issue.fetchWorkTypes);

    useEffect(() => {
        if (!open || netWorkStatus) {
            return;
        }
        departmentId && costCategoryAction(String(departmentId));
        fetchHPCodesAction();
        fetchWorkTypesAction();
    }, [open, netWorkStatus, departmentId, costCategoryAction, fetchHPCodesAction, fetchWorkTypesAction]);

    const formKey = `${mode}-${initialEntry?.id ?? 'new'}`;

    return (
        <Modal className={classes['timeEntryModel']} open={open} onClose={onClose} position="bottom">
            <Header mode={mode} />
            {open && (
                <Form
                    key={formKey}
                    onClose={onClose}
                    mode={mode}
                    workOrderId={workOrderId}
                    taskId={taskId}
                    type={type}
                    initialEntry={initialEntry}
                    onSaved={onSaved}
                />
            )}
        </Modal>
    );
};

export default TimeEntry;
